import React, { createContext, useState } from 'react';

const ModalContext = createContext({
  open: false,
  modal: 'none',
  details: {},
  pageUpdate: {},
  fixedsize: false,
  maxHeight: null,
  setMaxHeight: () => {},
  maxWidth: null,
  setMaxWidth: () => {},
  minWidth: null,
  setMinWidth: () => {},
  minHeight: null,
  setMinHeight: () => {},
  setDetails: () => {},
  setPageUpdate: () => {},
  openModal: () => {},
  openModalWithDetails: () => {},
  closeModal: () => {},
  setFixedsize: () => {}
});

export function ModalContextProvider(props) {
  const [open, setOpen] = useState(false);
  const [modal, setModal] = useState('none');
  const [details, setDetails] = useState({});
  const [pageUpdate, setPageUpdate] = useState({});
  const [fixedsize, setFixedsize] = useState(false);
  const [maxHeight, setMaxHeight] = useState(null);
  const [maxWidth, setMaxWidth] = useState(null);
  const [minWidth, setMinWidth] = useState(null);
  const [minHeight, setMinHeight] = useState(null);

  function openModalHandler() {
    setOpen(true);
  }

  function closeModalHandler() {
    setFixedsize(false)
    setOpen(false);
  }

  function setDetailsHandler(modal, data) {
    setModal(modal);
    setDetails(data);
  }

  function openModalWithDetailsHandler(modal, data) {
    setModal(modal);
    setDetails(data);
    setOpen(true);
  }

  function setPageUpdateHandler(data) {
    setPageUpdate(data);
  }

  function setFixedsizeHandler(data) {
    setFixedsize(data);
  }

  const context = {
    open,
    modal,
    details,
    pageUpdate,
    fixedsize,
    maxHeight,
    setMaxHeight,
    maxWidth,
    setMaxWidth,
    minWidth,
    setMinWidth,
    minHeight,
    setMinHeight,
    setDetails: setDetailsHandler,
    setPageUpdate: setPageUpdateHandler,
    openModal: openModalHandler,
    openModalWithDetails: openModalWithDetailsHandler,
    closeModal: closeModalHandler,
    setFixedsize: setFixedsizeHandler
  };

  return (
    <ModalContext.Provider value={context}>
      {props.children}
    </ModalContext.Provider>
  );
}

export default ModalContext;